import styled from 'styled-components';
export const VideoWrapper = styled.div`
  background: white; color: #1b264f;
  .video-section { max-width: 1360px; margin: auto; padding: 72px 40px; }
  .video-hero { position: relative; z-index: 1; padding-top: 36px; }
  .video-split { display: grid; grid-template-columns: 1fr 1.08fr; gap: 56px; align-items: center; }
  .video-eyebrow { font: 700 14px/1.5 Poppins, sans-serif; letter-spacing: .14em; text-transform: uppercase; color: #2c5bff; margin: 0 0 14px; }
  h1 { font: 600 clamp(36px,3.8vw,56px)/1.13 Poppins,sans-serif; letter-spacing: -.045em; color: #1b264f; margin: 0 0 24px; text-transform: none; }
  h1 span { display: block; color: #2c5bff; }
  .video-title { font: 600 clamp(28px,3vw,42px)/1.2 Poppins,sans-serif; letter-spacing: -.035em; text-transform: none; color: #1b264f; margin: 0 0 20px; }
  .video-copy { font: 400 18px/1.7 'Nunito Sans',sans-serif; color: #52617e; margin: 0 0 24px; max-width: 660px; }
  h3 { font: 600 21px/1.4 Poppins,sans-serif; color: #1b264f; text-transform: none; margin: 0 0 12px; }
  .video-actions { display: flex; flex-wrap: wrap; gap: 24px; align-items: center; }
  .video-primary { border: 0; border-radius: 8px; background: #2c5bff; color: white; padding: 18px 26px; font: 600 15px/1.5 Poppins,sans-serif; cursor: pointer; }
  .video-primary:hover { background: #2049d6; }
  .video-link { color: #2c5bff; font: 600 16px/1.5 'Nunito Sans',sans-serif; text-decoration: underline; text-underline-offset: 4px; }
  .video-promises { display: flex; flex-wrap: wrap; gap: 12px 20px; margin: 24px 0 0; padding: 0; list-style: none; font: 600 15px/1.5 'Nunito Sans',sans-serif; }
  .video-promises li::before { content: '✓'; color: #2c5bff; margin-right: 8px; }
  .video-hero-media { position: relative; isolation: isolate; display: grid; justify-items: center; margin: 0; }
  .video-hero-media::before { content: ''; position: absolute; z-index: -1; inset: 8% 0; background: radial-gradient(ellipse, #e6edff 0%, #f4f7ff 45%, transparent 72%); }
  .video-portrait { position: relative; width: 100%; aspect-ratio: 9/16; background: #f6f8fc; overflow: hidden; border-radius: 14px; }
  .video-embed, .video-poster, .video-player { position: absolute; inset: 0; width: 100%; height: 100%; }
  .video-poster { display: block; object-fit: cover; pointer-events: none; opacity: 1; transition: opacity .18s ease; }
  .video-player { opacity: 0; pointer-events: none; transition: opacity .18s ease; }
  .video-player > div, .video-player > div > div, .video-player iframe { position: absolute !important; inset: 0; width: 100% !important; height: 100% !important; border: 0; }
  .video-embed.is-ready .video-player { opacity: 1; pointer-events: auto; }
  .video-embed.is-ready .video-poster { opacity: 0; }
  .video-fallback { position: absolute; bottom: 20px; left: 20px; right: 20px; text-align: center; background: white; color: #1b264f; padding: 12px; border-radius: 8px; font: 600 16px/1.5 Poppins,sans-serif; }
  @media(prefers-reduced-motion:reduce) { .video-player, .video-poster { transition: none; } }
  .video-featured-player { max-width: 315px; box-shadow: 0 18px 48px #1b264f1f; }
  .video-hero-media figcaption { margin-top: 16px; font: 600 15px/1.5 'Nunito Sans',sans-serif; color: #52617e; }
  .video-section-heading { max-width: 820px; }
  .video-format-grid { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); gap: 64px; margin-top: 36px; }
  .video-format-grid article { padding-top: 24px; border-top: 1px solid #dce3ef; }
  .video-format-label { display: block; font: 600 14px/1.5 Poppins,sans-serif; color: #2c5bff; margin-bottom: 12px; }
  .video-format-grid p, .video-format-grid li { font: 400 17px/1.65 'Nunito Sans',sans-serif; color: #52617e; }
  .video-format-grid p { margin: 0 0 20px; }
  .video-format-grid ul { list-style: none; margin: 0; padding: 0; }
  .video-format-grid li { margin-top: 8px; }
  .video-format-grid li::before { content: '✓'; color: #2c5bff; margin-right: 10px; }
  .video-examples-band { background: #f6f8fc; scroll-margin-top: 24px; }
  .video-examples-heading { display: flex; align-items: end; justify-content: space-between; gap: 48px; margin-bottom: 36px; }
  .video-examples-heading .video-title { margin-bottom: 0; }
  .video-examples-heading .video-copy { max-width: 340px; margin-bottom: 0; }
  .video-mobile-hint { display: none; }
  .video-examples-grid { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); gap: 40px; }
  .video-examples-grid figure { margin: 0 auto; width: 100%; max-width: 315px; }
  .video-examples-grid figcaption { margin-top: 20px; }
  .video-examples-grid h3 { font-size: 19px; margin-bottom: 8px; }
  .video-examples-grid p { font: 400 16px/1.65 'Nunito Sans',sans-serif; color: #52617e; margin: 0; }
  .video-process-grid { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); gap: 40px; margin-top: 36px; }
  .video-process-grid article { border-top: 1px solid #dce3ef; padding-top: 22px; }
  .video-step { display: block; font: 600 30px/1.2 Poppins,sans-serif; color: #2c5bff; margin-bottom: 18px; }
  .video-process-grid p { font: 400 17px/1.65 'Nunito Sans',sans-serif; color: #52617e; margin: 0; }
  .video-related { text-align: center; padding-bottom: 36px; }
  .video-related .video-copy { margin-left: auto; margin-right: auto; }
  .video-related-grid { display: grid; grid-template-columns: repeat(4,minmax(0,1fr)); gap: 24px; margin-top: 32px; }
  .video-related-card { display: block; text-decoration: none; color: #1b264f; border: 1px solid #e4e8ef; border-radius: 14px; overflow: hidden; text-align: left; background: white; }
  .video-related-card:hover { box-shadow: 0 10px 26px #1b264f10; }
  .video-related-card img { display: block; width: 100%; height: 180px; object-fit: cover; }
  .video-related-content { padding: 20px; }
  .video-related-card h3 { font-size: 18px; }
  .video-related-card p { color: #52617e; font: 400 15px/1.6 'Nunito Sans',sans-serif; margin-bottom: 12px; }
  .video-related-arrow { color: #2c5bff; font-weight: 600; font-size: 15px; }
  .video-tour-link { margin: 24px 0 0; }
  .video-faq-layout { display: grid; grid-template-columns: .8fr 1.2fr; gap: 64px; align-items: start; padding-top: 36px; }
  .video-faq details { border-bottom: 1px solid #e4e8ef; padding: 20px 0; }
  .video-faq details:first-child { padding-top: 0; }
  .video-faq summary { font: 600 18px/1.5 Poppins,sans-serif; cursor: pointer; }
  .video-faq p { margin: 16px 0 0; font: 400 17px/1.7 'Nunito Sans',sans-serif; color: #52617e; }
  .video-final-section { padding-top: 0; padding-bottom: 64px; }
  .video-final { display: grid; grid-template-columns: 1.15fr 1fr; background: #1b264f; border-radius: 16px; overflow: hidden; }
  .video-final-copy { padding: 36px; }
  .video-final .video-title { font-size: clamp(28px,2.7vw,36px); color: white; margin-bottom: 16px; }
  .video-final .video-eyebrow { color: #b7c8ff; }
  .video-final .video-copy { color: #d7dfef; font-size: 17px; margin-bottom: 20px; }
  .video-final .video-link { color: white; }
  .video-final-visual { position: relative; overflow: hidden; min-width: 0; }
  .video-final-visual img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; transform: scale(1.25); }
  button:focus-visible, a:focus-visible, summary:focus-visible { outline: 3px solid #7c9aff; outline-offset: 5px; }
  @media(max-width:991px) {
    .video-split { gap: 32px; }
    .video-related-grid { grid-template-columns: repeat(2,minmax(0,1fr)); }
    .video-examples-heading { display: block; }
    .video-examples-heading .video-copy { max-width: 660px; margin-top: 16px; }
    .video-examples-grid { gap: 24px; }
  }
  @media(max-width:767px) {
    .video-section { padding: 44px 20px; }
    .video-hero { padding-top: 28px; }
    .video-split { grid-template-columns: 1fr; gap: 32px; }
    h1 { font-size: clamp(34px,8.5vw,48px); }
    .video-copy { font-size: 17px; }
    .video-featured-player { max-width: 280px; }
    .video-format-grid { grid-template-columns: 1fr; gap: 28px; margin-top: 28px; }
    .video-format-grid h3 { font-size: 20px; }
    .video-format-grid p, .video-format-grid li { font-size: 16px; }
    .video-examples-heading { margin-bottom: 28px; }
    .video-mobile-hint { display: block; font: 600 15px/1.5 'Nunito Sans',sans-serif; color: #52617e; margin: 0 0 16px; }
    .video-examples-grid { display: flex; gap: 20px; overflow-x: auto; scroll-snap-type: x mandatory; margin-right: -20px; padding-right: 20px; padding-bottom: 12px; scrollbar-width: thin; }
    .video-examples-grid figure { flex: 0 0 min(82%,280px); max-width: 280px; margin: 0; scroll-snap-align: start; }
    .video-process-grid { grid-template-columns: 1fr; gap: 28px; margin-top: 28px; }
    .video-process-grid article { display: grid; grid-template-columns: 42px 1fr; column-gap: 16px; padding-top: 20px; }
    .video-step { grid-row: span 2; font-size: 26px; margin-bottom: 0; }
    .video-process-grid h3 { font-size: 19px; margin-bottom: 8px; }
    .video-process-grid p { grid-column: 2; font-size: 16px; }
    .video-related { padding-bottom: 24px; }
    .video-related-grid { grid-template-columns: repeat(2,minmax(0,1fr)); gap: 12px; margin-top: 24px; }
    .video-related-card img { height: 150px; }
    .video-related-content { padding: 16px 12px; }
    .video-related-card h3 { font-size: 16px; }
    .video-related-card p { font-size: 14px; }
    .video-faq-layout { grid-template-columns: 1fr; gap: 28px; padding-top: 24px; }
    .video-faq summary { font-size: 16px; }
    .video-final-section { padding-top: 0; }
    .video-final { display: block; text-align: center; }
    .video-final-copy { padding: 28px 24px; }
    .video-final .video-actions { justify-content: center; }
    .video-final-visual { display: none; }
  }
`;
